module.exports = "/_next/static/images/0a222600f03e12ba0162e13bded4e002-phone-and-card@3x.png.webp";